export const uiSchemaFnc = (showConsentToShare: boolean) => {
  return {
    absenceReason: {
      id: {
        "ui:title": "Reason",
        "ui:widget": "select",
      },
    },
    consentToShare: {
      "ui:title": "Are you happy for your employer to be told the reason for your absence?",
      "ui:widget": showConsentToShare ? "toggle" : "hidden",
    },

    isWorkRelated: {
      "ui:title": "Was your absence caused by an issue or incident in the workplace?",
      "ui:widget": "toggle",
    },
    isAccidentRelated: {
      "ui:title": "Was your absence due to an accident in the workplace?",
      "ui:widget": "toggle",
    },
  };
};
